@let roomSettings = roomSettingsSignal();

<p class="ui-heading-2-bold--s">Edit Meeting room</p>
<rds-tabs
  ariaLabel="Edit meeting room tabs"
  (selectedTabChange)="isDetailsTabActive.set($event.index === 0)">
  <rds-tab label="Details">
    <div [formGroup]="roomConfigForm">
      <div class="room-details-container">
        @if (isLoading()) {
          <div class="loader full-width">
            <rds-progress-spinner></rds-progress-spinner>
          </div>
        }

        @if (roomSettings) {
          <rds-form-field labelPosition="top">
            <rds-control-label>Location/Site</rds-control-label>
            <input rdsInput [value]="roomSettings.siteName" disabled />
          </rds-form-field>
          <rds-form-field labelPosition="top">
            <rds-control-label>Building/Floor</rds-control-label>
            <input
              rdsInput
              [value]="
                roomSettings.buildingName + ' / ' + roomSettings.floorName
              "
              disabled />
          </rds-form-field>
          <rds-form-field labelPosition="top">
            <rds-control-label>Room Name</rds-control-label>
            <input rdsInput [value]="roomSettings.roomName" disabled />
          </rds-form-field>
          <rds-form-field labelPosition="top">
            <rds-control-label>Room Type</rds-control-label>
            <input rdsInput [value]="roomSettings.roomType" disabled />
          </rds-form-field>
        }

        <div>
          <p>Room status</p>
          <rds-radio-group class="d-flex flex-column" formControlName="active">
            <rds-radio-button [value]="true">Active</rds-radio-button>
            <rds-radio-button [value]="false">Inactive</rds-radio-button>
          </rds-radio-group>
        </div>

        <div>
          <p>Automatic approval</p>
          <rds-radio-group
            class="d-flex flex-column"
            formControlName="automaticApproval">
            <rds-radio-button [value]="true" checked>Yes</rds-radio-button>
            <rds-radio-button [value]="false">No</rds-radio-button>
          </rds-radio-group>
        </div>

        <div>
          <p>5 days freeze</p>
          <rds-radio-group
            class="d-flex flex-column"
            formControlName="freezeDays">
            <rds-radio-button [value]="5">Yes</rds-radio-button>
            <rds-radio-button [value]="0">No</rds-radio-button>
          </rds-radio-group>
        </div>

        <div>
          <p>Security and Compliance Service</p>
          <rds-radio-group
            class="d-flex flex-column"
            formControlName="generalQuestionsEnabled">
            <rds-radio-button [value]="true" checked>Yes</rds-radio-button>
            <rds-radio-button [value]="false">No</rds-radio-button>
          </rds-radio-group>
        </div>

        @if (servicesControlsSignal()) {
          <div class="full-width">
            <p>Services</p>
            <div class="services-container" formGroupName="services">
              @for (service of roomServices(); track service.id) {
                <rds-switch [formControlName]="service.type">{{
                  service.name
                }}</rds-switch>
              }
            </div>
          </div>
        }

        <div class="two-column-row full-width">
          <div>
            <p>Room blocking time</p>
            <rds-radio-group
              class="d-flex flex-column"
              formControlName="setBlockingTime"
              (buttonChanged)="toggleRoomBlockingTime($event)">
              <rds-radio-button [value]="true" checked>Yes</rds-radio-button>
              <rds-radio-button [value]="false">No</rds-radio-button>
            </rds-radio-group>
            @if (roomConfigForm.controls.setBlockingTime.value) {
              <div formArrayName="blockingTimes" class="blocking-times-section">
                <p>Specify daily block time</p>
                @for (
                  time of roomConfigForm.controls.blockingTimes.controls;
                  track time;
                  let last = $last
                ) {
                  <div class="time-container" [formGroup]="time">
                    <div class="time-control">
                      <rds-form-field labelPosition="top">
                        <rds-control-label>From</rds-control-label>
                        <input
                          rdsInput
                          [matTimepicker]="fromPicker"
                          [placeholder]="'HH:mm'"
                          formControlName="from" />
                        <mat-timepicker-toggle
                          rds-control-suffix
                          [for]="fromPicker" />
                        <mat-timepicker #fromPicker />
                      </rds-form-field>
                      <rds-form-field labelPosition="top">
                        <rds-control-label>To</rds-control-label>
                        <input
                          rdsInput
                          [matTimepicker]="toPicker"
                          [placeholder]="'HH:mm'"
                          formControlName="to" />
                        <mat-timepicker-toggle
                          rds-control-suffix
                          [for]="toPicker" />
                        <mat-timepicker #toPicker />
                      </rds-form-field>
                    </div>
                    @if (last) {
                      <button
                        rds-icon-button
                        size="s"
                        (click)="addBlockingTime()">
                        <rds-icon namespace="filled" icon="plus"></rds-icon>
                      </button>
                      @if (
                        roomConfigForm.controls.blockingTimes.controls.length >
                        1
                      ) {
                        <button
                          rds-icon-button
                          size="s"
                          (click)="removeBlockingTime()">
                          <rds-icon namespace="filled" icon="minus"></rds-icon>
                        </button>
                      }
                    }
                  </div>
                }
              </div>
            }
          </div>

          <div>
            <p>Meeting duration time</p>
            <rds-radio-group
              class="d-flex flex-column"
              formControlName="setMeetingDurationRangeTime">
              <rds-radio-button [value]="true">Yes</rds-radio-button>
              <rds-radio-button [value]="false">No</rds-radio-button>
            </rds-radio-group>
            @if (roomConfigForm.controls.setMeetingDurationRangeTime.value) {
              <div class="meeting-duration-form">
                <p class="ui-label-m-bold">Minimum</p>
                <div
                  class="meeting-duration-controls"
                  [formGroup]="
                    roomConfigForm.controls.durationRange.controls.min
                  ">
                  <rds-form-field labelPosition="top">
                    <rds-control-label>Days</rds-control-label>
                    <input
                      rdsInput
                      formControlName="days"
                      min="0"
                      type="number" />
                  </rds-form-field>
                  <rds-form-field labelPosition="top">
                    <rds-control-label>Hours</rds-control-label>
                    <input
                      rdsInput
                      formControlName="hours"
                      min="0"
                      type="number" />
                  </rds-form-field>
                  <rds-form-field labelPosition="top">
                    <rds-control-label>Minutes</rds-control-label>
                    <input
                      rdsInput
                      formControlName="minutes"
                      min="0"
                      type="number" />
                  </rds-form-field>
                </div>
              </div>
              <div class="meeting-duration-form">
                <p class="ui-label-m-bold">Maximum</p>
                <div
                  class="meeting-duration-controls"
                  [formGroup]="
                    roomConfigForm.controls.durationRange.controls.max
                  ">
                  <rds-form-field labelPosition="top">
                    <rds-control-label>Days</rds-control-label>
                    <input
                      rdsInput
                      formControlName="days"
                      min="0"
                      type="number" />
                  </rds-form-field>
                  <rds-form-field labelPosition="top">
                    <rds-control-label>Hours</rds-control-label>
                    <input
                      rdsInput
                      formControlName="hours"
                      min="0"
                      type="number" />
                  </rds-form-field>
                  <rds-form-field labelPosition="top">
                    <rds-control-label>Minutes</rds-control-label>
                    <input
                      rdsInput
                      formControlName="minutes"
                      min="0"
                      type="number" />
                  </rds-form-field>
                </div>
              </div>
            }
          </div>
        </div>

        <rds-form-field labelPosition="top" class="full-width">
          <rds-control-label
            ><p class="marked-link">
              Description
              <rds-icon
                namespace="outlined"
                icon="circle_info"
                [rdsTooltip]="tooltipContent"
                [rdsTooltipHideDelay]="2000"
                rdsTooltipAriaDescription="How to add a link in description"></rds-icon>
              <ng-template #tooltipContent>
                <div>
                  To create a link, enclose the link text in brackets (e.g.,
                  [More details]) and then follow it immediately with the URL in
                  parentheses (e.g., (https://bookly.roche.com)). For more
                  details and possible options visit
                  <a
                    rds-link
                    href="https://www.markdownguide.org/basic-syntax/"
                    target="_blank"
                    >basic syntax</a
                  >
                </div>
              </ng-template>
            </p>
          </rds-control-label>
          <textarea rdsInput formControlName="description"></textarea>
        </rds-form-field>

        <div class="full-width tags-section">
          <p class="ui-label-m-bold">Tags</p>
          <div class="tag-input-row">
            <rds-form-field labelPosition="top" class="tag-input-field">
              <input
                rdsInput
                formControlName="tagInput"
                placeholder="Example: pRed"
                (keydown.enter)="onTagInputEnter($event)" />
            </rds-form-field>
            <button
              rds-secondary-button
              size="m"
              type="button"
              class="tag-add-button"
              (click)="addTag()"
              [disabled]="
                roomConfigForm.controls.tagInput.invalid ||
                !roomConfigForm.controls.tagInput.value.trim()
              ">
              Add tag
            </button>
          </div>

          @if (roomConfigForm.controls.tagInput.hasError('pattern')) {
            <p class="tag-validation-error">
              Tag must be a single string without spaces.
            </p>
          }

          @if (roomConfigForm.controls.tagInput.hasError('duplicateTag')) {
            <p class="tag-validation-error">
              Tag already exists. Please enter a unique tag.
            </p>
          }

          @if (roomConfigForm.controls.tags.value.length > 0) {
            <div class="tags-chip-set">
              @for (tag of roomConfigForm.controls.tags.value; track tag) {
                <rds-chip size="m" closable (closeChip)="removeTag(tag)">
                  {{ tag }}
                </rds-chip>
              }
            </div>
          }
        </div>

        @if (activeLayouts().length > 0) {
          <div class="table full-width">
            <bad-layout-table
              (selectedLayout)="updateDefaultLayout($event)"
              (removeLayout)="removeLayout($event)"
              (editLayout)="openLayoutEditDialog($event)"
              [roomLayout]="roomLayouts()"
              [defaultLayout]="
                roomSettings?.manageSpaceConfiguration?.defaultLayoutId
              "></bad-layout-table>
          </div>
        }
      </div>
    </div>
  </rds-tab>
  <rds-tab label="History">
    <bad-room-history
      [entries]="roomHistory()"
      [isLoading]="isRoomHistoryLoading()" />
  </rds-tab>
</rds-tabs>

<!--
  Outside rds-tabs so it pins to the bottom of the page rather than the end of
  the Details form. Only the Details tab has actions, hence the gate.
-->
@if (isDetailsTabActive()) {
  <div class="room-details-actions">
    <button rds-primary-button size="m" (click)="openLayoutUploadDialog()">
      Upload new room layout
    </button>
    <span class="actions-spacer"></span>
    <button rds-secondary-button (click)="goBack()" size="m">Cancel</button>
    <button
      rds-primary-button
      size="m"
      (click)="updateRoomConfig()"
      [disabled]="roomConfigForm.invalid || !roomConfigForm.dirty">
      Save
    </button>
  </div>
}
